/**
 * Event sale stats — sold-vs-capacity per event, for event-list.view.ts's
 * own footer slot fill on event-tile.view.ts. Keyed by event id (never a
 * flat map filtered by id) so every event on the page carries its own
 * figures without clobbering a sibling's. Populated only for an actor
 * holding tickets.reports.view (+ mfa — quota.entity.ts's own read gate);
 * stats.sync.ts (web-side) is the sole writer, and simply omits an
 * event whose quota read that actor can't make rather than surfacing a
 * denial on the card.
 *
 * Revenue is deliberately absent here. Per-event revenue is a full scan of
 * that event's paid orders (Order's money lives in `lines[].amount`,
 * unreachable by a Firestore aggregate) — affordable for one selected
 * event, but multiplied across every event on this list it is exactly the
 * read-cost explosion the restraint exists to prevent. A
 * cheap per-event rollup would need a maintained counter — a dedicated
 * trigger summing revenue on order settlement, mirroring how
 * event.availability is maintained rather than derived on read — which
 * doesn't exist yet.
 */
import { state } from "@mhmo91/schmancy/state";

export type EventSaleStats = {
	readonly sold: number;
	readonly capacity: number;
};

export const eventSaleStats = state<ReadonlyMap<string, EventSaleStats>>(
	"events/sale-stats",
).memory(new Map());
